import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetCascadedPlansApi from "../api/plans/GetCascadedPlansApi";
import { SimpleLoader } from "./sub/Loaders";
import TopPlanElement from "./TopPlanElement";

function TopPlansSpace(props) {
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPlanId, setCurrentPlanId] = useState();
  const [startAt, setStartAt] = useState(0);
  const [totalChildCount, setTotalChildCount] = useState(0);
  const [isCascadedPlanDeleted, setIsCascadedPlanDeleted] = useState(false);
  const [isPlanCascaded, setIsPlanCascaded] = useState(false);

  useEffect(() => {
    if (data.length === 0) {
      if (props.activeKeys.includes(props.planId)) {
        getCascadedPlans(props.planId, startAt);
        setCurrentPlanId(props.planId);
      }
    }
  }, [props.activeKeys]);

  useEffect(() => {
    if (props.cascadedData) {
      if (!props.collapse) {
        // 🔑 NEW: Add new cascaded plan at the TOP of the list
        const newData = [props.cascadedData, ...data];
        setData(newData);
        setTotalChildCount(totalChildCount + 1);
        setIsPlanCascaded(true);
        setStartAt(startAt + 1);
      } else {
        getCascadedPlans(props.planId, startAt);
      }
    }
  }, [props.cascadedData]);

  // 🔑 NEW: Listen for hierarchy changes and refresh cascade plans
  useEffect(() => {
    const handleHierarchyChange = (event) => {
      // Only refresh if this is the parent plan that had hierarchy changes
      if (event.detail.parentPlanId === props.planId) {
        refreshCascadePlans();
      }
    };

    // Listen for hierarchy changes
    window.addEventListener('cascadeHierarchyChanged', handleHierarchyChange);

    // Cleanup
    return () => {
      window.removeEventListener('cascadeHierarchyChanged', handleHierarchyChange);
    };
  }, [props.planId]);

  // 🔑 NEW: Refresh cascade plans (force reload with hierarchy order)
  async function refreshCascadePlans() {
    setLoading(true);
    
    const apiResponse = await GetCascadedPlansApi(
      perfCycleState.id,
      props.planId,
      positionState.id,
      0, // Start from beginning
      100 // Get all plans
    );
    
    if (apiResponse.message === "success") {
      setData(apiResponse.data.plans); // Replace all data with fresh hierarchy-ordered data
      setTotalChildCount(apiResponse.data?.totalCount);
      setStartAt(apiResponse.data.plans.length);
    }
    setLoading(false);
  }

  async function getCascadedPlans(id, num) {
    setLoading(true);
    const apiResponse = await GetCascadedPlansApi(
      perfCycleState.id,
      id,
      positionState.id,
      num,
      10
    );
    if (apiResponse.message === "success") {
      setData([...data, ...apiResponse.data.plans]);

      setTotalChildCount(apiResponse.data?.totalCount);
      setIsCascadedPlanDeleted(false);
      setIsPlanCascaded(false);
    }
    setLoading(false);
  }

  function handleDelete(planId) {
    setIsCascadedPlanDeleted(true);
    setTotalChildCount(totalChildCount - 1);
    setStartAt(startAt + (10 - 1));

    const newData = [];
    data.forEach((element) => {
      if (planId !== element.planId) {
        newData.push(element);
      }
    });
    setData(newData);
  }
  function handleEdit(editedPlan) {
    const newData = data.map((element) => {
      if (editedPlan.planId === element.planId) {
        return editedPlan;
      }
      return element;
    });
    setData(newData);
  }

  return (
    <>
      {data?.map((element) => (
        <TopPlanElement
          key={element.planId}
          data={element}
          handleDelete={(planId) => handleDelete(planId)}
          handleEdit={(planId) => handleEdit(planId)}
          handleDeleteChange={(planId, totalChildCount) =>
            props.handleDeleteChange(planId, totalChildCount)
          }
          totalChildCount={totalChildCount}
        />
      ))}

      {loading ? (
        <SimpleLoader />
      ) : totalChildCount > data.length ? (
        <div className="flex items-center justify-center mt-2">
          <Button
            className="mb-2"
            onClick={() => {
              getCascadedPlans(
                currentPlanId,
                isCascadedPlanDeleted || isPlanCascaded ? startAt : startAt + 10
              );
              setStartAt(startAt + 10);
            }}
          >
            Load more
          </Button>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default TopPlansSpace;
